import { render, staticRenderFns } from "./ClientReview.vue?vue&type=template&id=718542da&"
import script from "./ClientReview.vue?vue&type=script&lang=js&"
export * from "./ClientReview.vue?vue&type=script&lang=js&"
import style0 from "./ClientReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports